import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  IconButton,
  Slider,
  Stack,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { Postrequestcall } from "../../request/Postrequest";
import { BIGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_EMP_JOBS_2, FETCH_CLIENT_TAKE_5_RECORDING } from "../../constant/Apipath";
import ClientTakeFiveAddModel from "./ClientTakeFiveAddModel";
import ClientViewRecordings from "./ClientViewRecordings";
import "./Take5.css";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

export default function ClientTakeFive() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const [jobList, setJobsList] = useState([]);
  const [isLoading, setLoading] = useState(false);

  //for multi language
  const LANGUAGE = ClientEnglishFallback.ClientTakeFive(multiLanguageData?.ClientTakeFive || {});

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeId: selectedClientData?.ClientEmployeeId
          }
        ]
      };

      let res = await Postrequestcall(FETCH_CLIENT_EMP_JOBS_2, obj, loginData?.accessToken);
      if (res?.status === 200) {
        let data = res?.data?.data?.map((data) => {
          return {
            ...data,
            innerIsPlaying: false
          };
        });

        setLoading(false);
        setJobsList(data);
      }
    } catch (error) {
      console.error("fetchJobs-> Error Getting Job: ", error);
      setLoading(false);
    }
  };
  return (
    <>
      {isLoading ? (
        <Loader fullScreen={true} />
      ) : (
        <>
          {jobList?.length !== 0 ? (
            <Grid container spacing={1}>
              {jobList?.map((job, index) => (
                <AccordionComponent
                  jobdata={job}
                  setJobsList={setJobsList}
                  index={index}
                  key={index}
                  LanguageDate={LANGUAGE}
                />
              ))}
            </Grid>
          ) : (
            <Stack sx={{ width: "100%", justifyContent: "center", alignItems: "center" }} height="85vh">
              <Typography>{LANGUAGE?.TEXT_NO_JOBS_AVAILABLE}</Typography>
            </Stack>
          )}
        </>
      )}
    </>
  );
}

const AccordionComponent = ({ jobdata, setJobsList, index, LanguageDate }) => {
  const [opeAddModal, setOpeAddModal] = useState(false);
  const { selectedClientData } = useSelector((state) => state?.main);
  const [take5Id, setTake5id] = useState(0);
  const reLoadDataRef = useRef();

  const handlePausePlay = () => {
    setJobsList((prev) =>
      prev.map((item) => ({
        ...item,
        innerIsPlaying: false
      }))
    );
  };

  return (
    <Grid size={12} key={index}>
      <Accordion key={index} defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon onClick={() => handlePausePlay()} />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{
            "& .MuiAccordionSummary-content": {
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "0 !important",
              paddingRight: "16px", // add padding so it doesn't overlap the expand icon
            },
          }}>
          <Stack sx={{ gap: 1 }} direction={"row"} >
            <LocationOnIcon
              sx={{
                color: selectedClientData?.AccentColor
              }}
            />
            <Typography>
              {jobdata?.jobCode}-{jobdata?.jobName}
            </Typography>
          </Stack>
          <div
            onClick={(e) => {
              e?.stopPropagation();
              setOpeAddModal(true);
            }}>
            <AddRoundedIcon
              style={{
                color: selectedClientData?.AccentColor
              }}
            />
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2} sx={{ width: "100%" }}>
            <Grid size={12} sx={{ width: "100%" }}>
              <AudioDetails
                ref={reLoadDataRef}
                jobdata={jobdata}
                setJobsList={setJobsList}
                takeFiveIdCallBack={(id) => {
                  setTake5id(id);
                }}
                LanguageDate={LanguageDate}
                selectedClientData={selectedClientData}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <ClientTakeFiveAddModel
        isOpen={opeAddModal}
        onClose={() => setOpeAddModal(false)}
        jobData={jobdata}
        take5Id={take5Id}
        reLoadData={() => reLoadDataRef.current.getjobListRecording()}
      />
    </Grid>
  );
};

const AudioDetails = forwardRef(
  ({ jobdata, setJobsList, takeFiveIdCallBack, LanguageDate, selectedClientData }, ref) => {
    const { loginData } = useSelector((state) => state?.main);
    const [recordingData, setRecordingData] = useState([]);
    const [recordingCount, setRecordingCount] = useState(0);
    const [takeFiveId, setTakeFiveId] = useState(0);
    const [viewRecordings, setViewRecordings] = useState(false);

    const { TEXT_NO_REPORT, TEXT_SEE, TEXT_MORE } = LanguageDate;
    useEffect(() => {
      if (jobdata) getjobListRecording();
    }, []);

    useImperativeHandle(ref, () => ({
      getjobListRecording
    }));

    const getjobListRecording = async () => {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 3,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeJobId: jobdata?.id
          }
        ],
        SortList: [{ FieldName: "dateCreated", Direction: "DESC" }]
      };
      let res = await Postrequestcall(FETCH_CLIENT_TAKE_5_RECORDING, obj, loginData?.accessToken);

      if (res?.status === 200) {
        let take5Id = res?.data?.data?.[0]?.id;
        setTakeFiveId(take5Id);

        takeFiveIdCallBack(take5Id);
        setRecordingCount(res?.data?.data?.[0]?.recordingCount || 0);

        if (res?.data?.data?.length > 0) {
          let temp = [];
          res?.data?.data?.[0]?.recordingList?.map((data) => {
            temp.push({
              ...data,
              isPlaying: false
            });
          });
          setRecordingData(temp);
        }
      }
    };

    return (
      <>
        {recordingData?.length === 0 ? (
          <Stack sx={{ gap: 1, display: "flex", width: "100%" }} direction={"column"}>
            <Typography sx={{ textAlign: "center", color: BIGrey }}>
              {TEXT_NO_REPORT}
            </Typography>
          </Stack>
        ) : (
          <Stack sx={{ gap: 1, display: "flex", width: "100%" }} direction={"column"}>
            {recordingData?.map((data, key) => (
              <AudioPlayerComponent
                key={key}
                setJobsList={setJobsList}
                data={data}
                jobdata={jobdata}
                index={key}
                setRecordingData={setRecordingData}
                selectedClientData={selectedClientData}
              />
            ))}
            {recordingCount > 3 && (
              <Button
                sx={{
                  backgroundColor: "lightgray",
                  boxShadow: "none",
                  color: "black",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "lightgray",
                    boxShadow: "none"
                  }
                }}
                onClick={() => setViewRecordings(true)}
                fullWidth
                variant="contained">
                {`${TEXT_SEE} ${recordingCount - 3} ${TEXT_MORE}`}
              </Button>
            )}
          </Stack>
        )}

        <ClientViewRecordings
          open={viewRecordings}
          onClose={() => setViewRecordings(false)}
          takeFiveId={takeFiveId}
        />
      </>
    );
  }
);

const AudioPlayerComponent = ({ data, setRecordingData, setJobsList, jobdata, index, selectedClientData }) => {
  const [toggle, setToggle] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!jobdata.innerIsPlaying) {
      setToggle(false);
      // audioRef.current.currentTime = 0;
      audioRef.current.pause();
      // setCurrentTime(0);
    }
    if (!data.isPlaying) {
      if (audioRef.current.currentTime > 0) {
        // audioRef.current.currentTime = 0;
        audioRef.current.pause();
        setToggle(false);
        // setCurrentTime(0);
      }
    }
  }, [data, jobdata]);

  useEffect(() => {
    if (currentTime === duration && duration != 0) {
      setToggle(false);
      setCurrentTime(0);
      audioRef.current.currentTime = 0;
    }
  }, [currentTime]);

  const handleTimeUpdate = (e) => {
    const current = audioRef.current.currentTime;
    const duration = audioRef.current.duration;

    if (current != 0) {
      setCurrentTime(current);
    }

    if (duration - current <= 0.3) {
      setToggle(false);
    }
  };

  const handleLoadedMetadata = (e) => {
    setDuration(audioRef.current.duration);
  };

  const handleSeek = (event) => {
    audioRef.current.currentTime = event.target.value;
    setCurrentTime(event.target.value);
  };

  const handleTogglePlay = () => {
    if (!toggle) {
      setJobsList((prev) =>
        prev?.map((item) =>
          item?.id === jobdata?.id
            ? {
                ...item,
                innerIsPlaying: true
              }
            : {
                ...item,
                innerIsPlaying: false
              }
        )
      );
    }
    if (toggle) {
      audioRef.current.pause();
      setRecordingData((prev) => prev?.map((item) => ({ ...item, isPlaying: false })));
    } else {
      audioRef.current.play();
      audioRef.current.currentTime = 0;
      setCurrentTime(0);
      setRecordingData((prev) =>
        prev?.map((item) =>
          item?.id === data?.id ? { ...item, isPlaying: true } : { ...item, isPlaying: false }
        )
      );
    }
    setToggle(!toggle);
  };

  return (
    <Stack
      sx={{
        display: "flex",
        padding: "10px",
        justifyContent: "center",
        height: "100%",
        border: "1px solid #e2e8f0",
        borderRadius: "10px",
        mb: 1
      }}
      key={index}
      direction={"column"}>
      <Typography>{dayjs(data?.dateCreated).format("MMMM DD, YYYY")}</Typography>
      <Stack sx={{ gap: 1,  display: "flex",  justifyContent: "space-between", alignItems: "center"  }}  direction={"row"} >
        <IconButton
          size="small"
          onClick={() => {
            handleTogglePlay();
          }}>
          {!toggle ? (
            <PlayArrowRoundedIcon fontSize="large" />
          ) : (
            <PauseRoundedIcon fontSize="large" />
          )}
        </IconButton>
        <Slider
          value={currentTime}
          min={0}
          step={0.01}
          max={duration}
          onChange={handleSeek}
          aria-labelledby="non-linear-slider"
          sx={{ color: selectedClientData?.AccentColor, flexGrow: 3, width: "100%" }}
        />
        <Typography variant="body2">{moment.utc(duration * 1000).format("m:ss")}</Typography>
      </Stack>

      <audio
        ref={audioRef}
        src={data?.fileUrl}
        type="audio/mp3"
        hidden
        controls
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        name="media"></audio>
    </Stack>
  );
};

